import { render, staticRenderFns } from "./IssueReport.vue?vue&type=template&id=6d7495f4&scoped=true&"
var script = {}
import style0 from "./IssueReport.vue?vue&type=style&index=0&id=6d7495f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7495f4",
  null
  
)

export default component.exports